import React from 'react';
import "./Presentation.scss";

const Presentation = () => {
  return (
    <div className="presentation-banner">
        <h2>
            Un concepto moderno de ejercer el Derecho, con un perfil preventivo y estratégico, adaptado a la toma de decisiones en empresas y particulares.
        </h2>
        <br></br>
        <p>
            Desde una mirada integral de la justicia, acompaño a empresas, equipos y líderes en la toma de decisiones clave, buscando siempre soluciones que permitan prevenir el conflicto judicial, privilegiando la negociación y el diálogo como herramientas poderosas para alcanzar acuerdos certeros, sostenibles y justos.
            Con una sólida formación y trayectoria interdisciplinaria, mi sello es acompañar a mis clientes desde la anticipación y buscando siempre el mejor acuerdo posible: prevenir antes que litigar, escuchar antes que imponer, negociar antes que perder. 
        </p>
    </div>
  )
}

export default Presentation